import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import { getParticipantInput, ParticipantListModel } from './model';

export function useGetParticipants(
  input?: getParticipantInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ParticipantListModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ParticipantListModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getParticipant', input?.params],
      () =>
        QueryFetchFunction({
          url: `tours/${input?.id}/get-participants`,
          params: input?.params,
        }),
      options,
    ),
    ParticipantListModel,
  );
}
